import { useState, useEffect } from 'react';

const useTags = () => {

    const [tags, setTags] = useState({});

    useEffect(() => {

        fetch("https://www.envirobat-oc.fr/?page=data-map&data=tags")
        .then(response => response.json())
        .then(data => {
            setTags(data);
        });

    }, []);

    return {
        tags
    }
}

export default useTags;